import { useState, useEffect } from "react";
import { X, Check } from "lucide-react";

export default function CardSelectModal({
  isOpen,
  onClose,
  selectedCard,
  cards = [],
  onSelect
}) {
  const [selected, setSelected] = useState(selectedCard);

  useEffect(() => {
    setSelected(selectedCard);
  }, [selectedCard]);

  // Format cards for display
  const formattedCards = cards.length > 0
    ? cards.map(card => ({
        ...card,
        displayName: card.card_type?.replace("_", " ").toUpperCase() || "Prepaid Card",
        displayNumber: card.card_number
          ? `****-****-****-${card.card_number.slice(-4)}`
          : "Card",
      }))
    : [];

  const handleSelect = (card) => {
    const displayNumber = card.card_number
      ? `****-****-****-${card.card_number.slice(-4)}`
      : "Card";
    setSelected(displayNumber);
    onSelect(card);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black/50" 
        onClick={onClose}
      />
      
      {/* Modal Content */}
      <div className="relative bg-background w-full max-w-md rounded-t-2xl animate-slide-up pb-16">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-border/20">
          <h3 className="text-lg font-semibold text-foreground">Select Card</h3>
          <button
            onClick={onClose}
            className="p-1 rounded-full hover:bg-gray-100"
          >
            <X className="w-5 h-5 text-foreground/60" />
          </button>
        </div>

        {/* Card List */}
        <div className="max-h-96 overflow-y-auto pb-4">
          {/* All Cards option */}
          <button
            onClick={() => {
              setSelected("All Card");
              onSelect(null);
              onClose();
            }}
            className="w-full flex items-center justify-between p-4 hover:bg-accent/50 border-b border-border/10"
          >
            <div className="text-left">
              <p className="font-medium text-foreground">All Card</p>
            </div>
            {selected === "All Card" && (
              <Check className="w-5 h-5 text-primary" />
            )}
          </button>

          {/* Card list */}
          {formattedCards.length === 0 ? (
            <div className="p-8 text-center">
              <p className="text-sm text-muted-foreground">No cards available</p>
            </div>
          ) : (
            formattedCards.map((card) => (
              <button
                key={card.id}
                onClick={() => handleSelect(card)}
                className="w-full flex items-center justify-between p-4 hover:bg-accent/50 border-b border-border/10 last:border-b-0"
              >
                <div className="text-left">
                  <p className="font-medium text-foreground">{card.displayName}</p>
                  <p className="text-sm text-muted-foreground mt-1">
                    {card.displayNumber}
                  </p>
                </div>
                {selected === card.displayNumber.replace(/ /g, '-') && (
                  <Check className="w-5 h-5 text-primary" />
                )}
              </button>
            ))
          )}
        </div>
      </div>
    </div>
  );
}